import React, { useEffect, useMemo } from "react";
import Select from "components/ui/Select";

// Constants moved to top to prevent re-renders
const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Non-Active" },
];

const SelectStatus = ({
  value,
  onChange,
  placeholder = "Select status",
  isDisabled = false,
  isRequired = false,
  label = "Status",
  className = "",
  showLabel = true,
}) => {
  // Memoize options for performance
  const memoizedStatusOptions = useMemo(() => statusOptions, []);

  // Auto-select the matching option when value is provided as simple object or number
  useEffect(() => {
    // If value is provided as a simple object with value field but no label, or as a number
    if (value && onChange) {
      // If value is a number (0 or 1), convert to option object
      if (typeof value === 'number' && (value === 0 || value === 1)) {
        const matchedOption = memoizedStatusOptions.find(option => option.value === value);
        if (matchedOption) {
          onChange(matchedOption);
        }
      }
      // If value is an object with value but no label, complete it
      else if (value.value !== undefined && !value.label) {
        const matchedOption = memoizedStatusOptions.find(option => option.value === value.value);
        if (matchedOption && matchedOption !== value) {
          onChange(matchedOption);
        }
      }
    }
  }, [value, onChange, memoizedStatusOptions]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={memoizedStatusOptions}
      getOptionValue={(option) => option?.value}
      getOptionLabel={(option) => option?.label}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      className={className}
      showLabel={showLabel}
      isClearable={false}
      isSearchable={false}
    />
  );
};

export default SelectStatus; 